import { Link } from "react-router-dom";
import { MapPin, Bed, Bath, Maximize } from "lucide-react";

export default function PropertyCard({ property }) {
  const typeLabels = { villa: "Villa", flat: "Apartment", land: "Land" };

  return (
    <Link
      to={`/properties/${property.id}`}
      data-testid="property-card-link"
      className="group block"
    >
      <div className="bg-navy-light border border-white/10 rounded-sm overflow-hidden transition-all duration-300 hover:border-gold/30">
        {/* Image */}
        <div className="relative aspect-[4/3] overflow-hidden">
          <img
            src={property.images?.[0] || "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800"}
            alt={property.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute top-4 left-4">
            <span className="bg-gold text-navy text-xs font-bold tracking-wider uppercase px-3 py-1.5">
              {typeLabels[property.property_type] || property.property_type}
            </span>
          </div>
          {property.is_featured && (
            <div className="absolute top-4 right-4">
              <span className="bg-navy/80 text-gold text-xs tracking-wider uppercase px-3 py-1.5 border border-gold/30">
                Featured
              </span>
            </div>
          )}
        </div>

        {/* Details */}
        <div className="p-5">
          <div className="flex items-center gap-2 mb-2">
            <MapPin size={13} className="text-gold" />
            <span className="text-xs text-beige/60 tracking-wider uppercase">{property.location}</span>
          </div>

          <h3 className="font-heading text-lg text-beige group-hover:text-gold transition-colors duration-300 mb-3 line-clamp-1">
            {property.title}
          </h3>

          <p className="text-sm text-beige/50 line-clamp-2 mb-4 leading-relaxed">
            {property.description}
          </p>

          <div className="flex items-center justify-between pt-3 border-t border-white/10">
            <span className="text-gold font-heading text-xl">
              {property.price_unit === "Cr" ? "\u20B9" : ""}{property.price} {property.price_unit}
            </span>

            <div className="flex items-center gap-3 text-beige/50">
              {property.bedrooms && (
                <span className="flex items-center gap-1 text-xs">
                  <Bed size={13} /> {property.bedrooms}
                </span>
              )}
              {property.bathrooms && (
                <span className="flex items-center gap-1 text-xs">
                  <Bath size={13} /> {property.bathrooms}
                </span>
              )}
              <span className="flex items-center gap-1 text-xs">
                <Maximize size={13} /> {property.area} {property.area_unit}
              </span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
